export default __webpack_public_path__ + "static/media/soy.653d2fed.svg";